import { Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader.tsx";

interface Props {
  isLoading: boolean;
  text?: string;
}

const TransitionLoader = ({ isLoading, children, text }: PropsWithChildren<Props>) => {
  return (
    <Stack sx={{ height: "100%", width: "100%", position: "relative" }}>
      {isLoading && (
        <InlineLoader
          overlay
          sx={{
            bgcolor: "background.paper",
            transition: "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",
            top: 0,
            left: 0,
            zIndex: 2,
          }}
          text={text}
        />
      )}
      <Stack
        sx={{
          height: "100%",
          width: "100%",
          opacity: !isLoading ? 1 : 0,
          transform: !isLoading ? "translateY(0)" : "translateY(10px)",
          transition: "opacity 0.4s ease-in-out 0.1s, transform 0.4s ease-in-out 0.1s",
          visibility: !isLoading ? "visible" : "hidden",
          pointerEvents: !isLoading ? "auto" : "none",
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
};

export default TransitionLoader;
